<template>
  <b-card>
    <b-row>
      <div class="m-2">
        <b-button class="float-left" variant="primarySpore" @click="back()">Regresar</b-button>
      </div>
    </b-row>
    <div>
      <b-row class="mt-1">

        <b-col md="12" lg="3">
          <b-card class="card_statisc">
            <b-row>
                <b-col md="6" class="mb-1" v-if="response.cfeCabinet">
                  <h4>Número gabinete: </h4>
                  <label class="font-medium-1 cursor-pointer" style="font-size: 20px" @click="redirect(response.cfeDevice.uuid)">{{response.cfeCabinet.number}}&nbsp;
                    <feather-icon icon="ExternalLinkIcon" size="18"/>
                  </label>
                </b-col>
                <b-col md="6" class="mb-1">

                </b-col>
                <b-col md="6" class="mb-1" v-if="response.cfeCabinet">
                  <h4>Número medidor: </h4>
                  <label class="font-medium-1" style="font-size: 20px">{{response.number}}</label>
                </b-col>
                <b-col md="6" class="mb-1">
                  <h4>Tipo de medidor: </h4>
                  <label class="font-medium-1" style="font-size: 20px">{{(response.type == 1 ? 'Monofásico': response.type == 2 ? 'Bifásico': response.type == 3 ? 'Trifásico': 'Otro') }}</label>
                </b-col>
                <b-col md="6" class="mb-1">
                  <h4>Fecha Ultima transmisión: </h4>
                  <label class="font-medium-1" style="font-size: 20px">{{ response.transmitedAt }}</label>
                </b-col>
            </b-row>
          </b-card>
        </b-col>

        <b-col cols="12" md="12">
          <div class="m-2">
            <!-- Table Top -->
            <b-row>
              <!-- Per Page -->
              <b-col cols="12" md="3" class="d-flex align-items-center justify-content-start mb-md-0">
                <label>Mostrar</label>
                <v-select v-model="filters.limit" :options="this.perPageOptions" :clearable="false" class="per-page-selector d-inline-block mx-50" @input="getMetersLogs"/>
                <label>Registros</label>
              </b-col>
              <b-col cols="12" md="3" class="d-flex align-items-center justify-content-start mb-md-0">
                <label for="example-datepicker">Desde</label>&nbsp;
                <b-form-datepicker id="beginDate" placeholder="" v-model="beginDate" class="mb-2"></b-form-datepicker>
              </b-col>
              <b-col cols="12" md="3" class="d-flex align-items-center justify-content-start mb-md-0">
                <label for="example-datepicker">Hasta</label>&nbsp;
                <b-form-datepicker id="finishDate" placeholder="" v-model="finishDate" class="mb-2"></b-form-datepicker>
              </b-col>
              <b-col cols="12" md="3" class="mt-2 text-right">
                <b-button variant="primarySpore" @click="getMetersLogs">
                  <feather-icon icon="SearchIcon" class="mr-50"/>
                  <span>Buscar</span>
                </b-button>
              </b-col>
            </b-row>
          </div>

          <b-table
              v-if="responseTable.length > 0"
              class="position-relative"
              hover
              responsive
              primary-key="id"
              show-emptysomething
              :items="responseTable"
              :fields="tableColumns"
            >
              <template #cell(Action)="data">
                <b-form-checkbox v-if="data.item.createdAt" v-model="data.detailsShowing" plain class="vs-checkbox-con" @change="data.toggleDetails">
                  <span class="vs-checkbox">
                    <span class="vs-checkbox--check">
                      <i class="vs-icon feather icon-check" />
                    </span>
                  </span>
                  <span class="vs-label">{{ data.detailsShowing ? 'Ocultar Lecturas' : 'Mostrar Lecturas' }}</span>
                </b-form-checkbox>
              </template>

              <template #row-details="data">
                <b-card>
                  <b-row class="mb-1">
                    <b-col md="3" class="mb-1">
                      <b-row class="mb-1">
                        <statistic-card-vertical icon="BatteryChargingIcon" :statistic="decimal(data.item.storedEnergy, 2) + ' Kw/h'" statistic-title="Energía Almacenada" color="primary"/>
                      </b-row>
                    </b-col>
                    <b-col md="3" class="mb-1">
                      <b-row class="mb-1">
                        <statistic-card-vertical icon="CloudLightningIcon" :statistic="decimal(data.item.electricCurrent, 3) + ' A'" statistic-title="Corriente" color="success"/>
                      </b-row>
                    </b-col>
                    <b-col md="3" class="mb-1">
                      <b-row class="mb-1">
                        <statistic-card-vertical icon="ZapIcon" :statistic="decimal(data.item.voltage, 2) + ' V'" statistic-title="Voltaje" color="info"/>
                      </b-row>
                    </b-col>
                    <b-col md="3" class="mb-1">
                      <b-row class="mb-1">
                        <statistic-card-vertical icon="ActivityIcon" :statistic="decimal(data.item.frecuency, 2) + ' Hz'" statistic-title="Frecuencia" color="warning"/>
                      </b-row>
                    </b-col>
                  </b-row>

                  <b-button variant="outline-info" @click="data.toggleDetails">
                    Ocultar Lecturas
                  </b-button>
                </b-card>
              </template>

              <template #cell(createdAt)="data">
                <div class="text-center">
                  {{ format(data.item.createdAt) }}
                </div>
              </template>
            </b-table>

          <div class="mx-2 mb-2">
            <b-row>

              <b-col cols="12" sm="6" class="d-flex align-items-center justify-content-center justify-content-sm-start">
                <!--<span class="text-muted">Showing {{ count }} of {{ totalRows }} entries</span>-->
              </b-col>
              <!-- Pagination -->
              <b-col cols="12" sm="6" class="d-flex align-items-center justify-content-center justify-content-sm-end">

                <b-pagination v-model="currentPage" :total-rows="this.totalRows" :per-page="this.filters.limit" first-number last-number class="mb-0 mt-1 mt-sm-0" prev-class="prev-item" next-class="next-item">
                  <template #prev-text>
                    <feather-icon icon="ChevronLeftIcon" size="18"/>
                  </template>
                  <template #next-text>
                    <feather-icon icon="ChevronRightIcon" size="18"/>
                  </template>
                </b-pagination>

              </b-col>

            </b-row>
          </div>
        </b-col>
        <br><br>
      </b-row>
    </div>

  </b-card>
</template>

<script>
import { formatDateLanguages, decimales, empty } from '@/libs/tools/helpers'
import StatisticCardVertical from '@core/components/statistics-cards/StatisticCardVertical.vue'
// import listItem from '@core/spore-components/listItem/listItem.vue'
import {
  BButton, BRow, BCol, BCard, VBTooltip, BTable, BPagination, BFormCheckbox, BFormDatepicker
} from 'bootstrap-vue'
import request from '@/libs/request/index'

export default {
  components: {
    BButton,
    BRow,
    BCol,
    BCard,
    BTable,
    BPagination,
    /* listItem, */
    BFormCheckbox,
    BFormDatepicker,
    StatisticCardVertical
  },
  directives: {
    'b-tooltip': VBTooltip
  },
  data () {
    return {
      uuid: this.$route.params.uuid,
      response: [],
      tableColumns: [
        { thClass: 'text-center', key: 'Action', label: 'Logs', thStyle: { width: '15%' } },
        { thClass: 'text-center', key: 'createdAt', sortable: true, label: 'Fecha de Creación' }
      ],
      totalRows: 0,
      currentPage: 1,
      perPageOptions: [10, 25, 50, 75, 100],
      perPage: 25,
      count: 0,
      responseTable: [],
      file: '',
      avatar: '',
      beginDate: '',
      finishDate: '',
      filters: {
        limit: 10,
        offset: 0,
        byColumn: 'id',
        byOrder: 'ASC',
        beginDate: '',
        finishDate: ''
      }
    }
  },
  methods: {
    decimal (val, n) {
      return decimales(val, n)
    },
    format (date) {
      return formatDateLanguages(date, 'hour')
    },
    redirect (uuid) {
      if (!empty(uuid)) {
        this.$router.push(`/gabinets/${uuid}/detail`)
      }
    },
    getSignalPercent (value) {
      value = parseInt(value)
      if (value === 99) return 'No conocido o no detectado'
      else if (value > 30) return '-52 dBm o muy buena'
      else if (value > 1 && value <= 30) return '-110... - 54 dBm'
      else if (value === 1) return '-111 dBm'
      else if (value === 0) return '-115 dBm o menor'
      return value
    },
    async getDetailDevice () {
      const params = {
        url: `/meters/${this.uuid}`,
        method: 'GET'
      }
      await request(params).then(data => {
        if (data.data.code === 200) {
          this.response = data.data.data[0]
          this.response.number = data.data.data[0].number.replace(/^(0)+/, '')
          this.getMetersLogs()
        }
      })
    },
    async getMetersLogs () {
      if (this.beginDate) {
        this.filters.beginDate = this.beginDate
      }
      if (this.finishDate) {
        this.filters.finishDate = this.finishDate
      }
      const params = {
        url: `/meters/log/list/${this.uuid}`,
        method: 'GET',
        params: this.filters
      }
      await request(params).then(data => {
        if (data.data.code === 200) {
          this.responseTable = data.data.data.rows
          this.totalRows = data.data.data.count
          this.count = data.data.data.rows.length
        }
      })
    },
    back () {
      this.$router.push(`/meters/${this.uuid}/detail`)
    }
  },
  created () {
    this.getDetailDevice()
  },
  watch: {
    currentPage (val) {
      this.filters.offset = (val - 1) * this.filters.limit
      this.getMetersLogs()
    },
    byColumn (val) {
      this.filters.byColumn = val
      this.currentx = 1
    }
  }
}
</script>

<style lang="scss">
  @import '@core/scss/vue/libs/vue-select.scss';
</style>
